import React, { useState } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IAccountRechargeDetail } from "../../../../AccountTypes";
import { useRechargeModel } from "./rechargeModel";
import { creditFlagRender } from "@/utils/utils";
import { SnippetsOutlined } from "@ant-design/icons";
import PreviewModal from "@/components/YhPreview/index";
import { httpRequest } from "@/utils/HttpRequest";
import { convertRes2Blob } from "@/utils/exportFile";
import { getBaseImgLookUrl } from "@/utils/constants"

type IPreviewInfoType = {
    visible: boolean,
    md5: string,
    fileName: string,
    filePath: string
    fileType: string
}

export function RechargeDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, setSelectedData,
        selectedData,
        loading,
    } = useRechargeModel();

    // 预览附件内容
    const [previewInfo, setPreviewInfo] = useState<IPreviewInfoType>({
        visible: false,
        md5: "",
        fileName: "",
        filePath: "",
        fileType: ""
    })

    // 打开附件弹框
    const onPreview = async (item: IAccountRechargeDetail) => {
        console.log("附件预览", item);
        let fileMd5 = item?.md5
        let fileName = item?.fileName as string
        let fileType = fileName?.substring(fileName.lastIndexOf(".") + 1) ?? 'png'
        let filePath = `${getBaseImgLookUrl(fileMd5 as string)}`
        if (fileType === 'docx') {
            const file = await httpRequest
                .postFile(filePath);
            return convertRes2Blob(file);
        }
        setPreviewInfo({
            visible: true,
            md5: fileMd5 as string,
            fileName,
            filePath,
            fileType
        })
    }

    // 关闭附件弹框
    const onCancel = () => {
        setPreviewInfo({ visible: false, md5: "", fileName: "", filePath: "", fileType: "" })
    }

    const columns: ColumnsType<IAccountRechargeDetail> = [
        {
            align: "center",
            title: '分支',
            dataIndex: 'branch',
        },
        // {
        //     title: '账户编码',
        //     dataIndex: 'code',
        // },
        {
            align: "center",
            title: '账户名称',
            dataIndex: 'accountName',
            render: (t, r) => r?.md5 === null
                ? <span>{t}</span>
                : <span style={{ position: "relative" }}>
                    {t}
                    <i style={{ position: "absolute", right: "-15px", top: "-3px", color: "#5200ff" }} onClick={() => onPreview(r)}>
                        <SnippetsOutlined />
                    </i>
                </span>
        },
        {
            align: "center",
            title: '授信类型',
            dataIndex: 'creditFlag',
            render: (v) => creditFlagRender(v)
        },
        {
            align: "center",
            title: '从属机构',
            dataIndex: 'orgName',
        },
        {
            align: "center",
            title: '账户实体',
            dataIndex: 'beName',
        },
        {
            align: "center",
            title: '原剩余金额',
            dataIndex: 'remainingAmount',
        },
        {
            align: "center",
            title: '充值金额',
            dataIndex: 'rechargeAmount',
        },
        {
            align: "center",
            title: '支付方式',
            dataIndex: 'payMethodName',
        },
        {
            align: "center",
            title: '审核状态',
            dataIndex: 'status',
            render: (v, r) => v === 1
                ? '审核通过(已调整)'
                : v === 3
                    ? '撤回'
                    : v === 8
                        ? '审核驳回'
                        : v === 9
                            ? '失败'
                            : '待审核'
        },
        {
            align: "center",
            title: '业务员',
            dataIndex: 'createUser',
        },
        {
            align: "center",
            title: '收款人',
            dataIndex: 'operator',
        },
        {
            align: "center",
            title: '充值日期',
            dataIndex: 'createTime',
        },
        {
            align: "center",
            title: '备注',
            dataIndex: 'note',
        },

    ];

    return (
        <>
            <Table
                loading={loading}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IAccountRechargeDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys);
                        selectedRows.length > 0 ? setSelectedData(selectedRows[0]) : setSelectedData(undefined)
                    },
                    selectedRowKeys
                }}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    showTotal: (total: number) => `共${total}条`,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize }).then();
                    }
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                                setSelectedRowKeys([]);
                                setSelectedData(undefined)
                            } else {
                                setSelectedRowKeys([record.key]);
                                setSelectedData(record)
                            }
                        },
                    };
                }}
                scroll={{ x: 'max-content' }}
            />
            {
                previewInfo.visible && <PreviewModal
                    visible={previewInfo.visible}
                    onCancel={onCancel}
                    md5Id={previewInfo.md5}
                    fileName={previewInfo.fileName}
                    filePath={previewInfo.filePath}
                    fileType={previewInfo.fileType}
                />
            }
        </>
    )
}

